import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FloorManagementService } from 'src/app/floor-management/floor-management.service';
import { Observable, Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { FloorUnit } from './floor-item-interfaces';
import { LANGUAGE_CONSTANTS } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-floor-item',
  templateUrl: './floor-item.component.html',
  styleUrls: ['./floor-item.component.scss'],
})
export class FloorItemComponent {
  @Input() name: String | undefined;
  @Input() wingName: String | undefined;
  @Input() floorId: String | undefined;
  readonly LANG_CONST = LANGUAGE_CONSTANTS;
  //Presentational component
  constructor() {}
}
